import { useAuth } from "../../contexts/AuthContext";
import { apiService } from "../../services/apiService";
import { frameStatisticsTimestamp } from "../../utils/frameStatisticsDate";
import { useParams } from "react-router-dom";
import { React, useEffect, useState } from "react";

const GameStats = () => {
    const { id } = useParams();
    const [game, setGame] = useState({});
    const [frames, setFrames] = useState([]);
    const [players, setPlayers] = useState([]);
    const [loading, setLoading] = useState(true);
    const { user } = useAuth();

    const getClubPlayers = async (id) => {
        const data = await apiService.post('/club/players', {
            id: id,
            include_default: true
        });
        setPlayers(data.players);
    };

    const getPlayerName = (playerId) => {
        if (!playerId || players.length === 0) return '';
        const player = players.find(p => p.id === parseInt(playerId));
        return player ? player.name : '';
    };

    useEffect(() => {
        const getGame = async () => {
            const data = await apiService.post('/club/game-link', {
                link: id,
            });
            setGame(data.game);
        };

        const getGameFrames = async () => {
            const data = await apiService.post('/club/game/frames', {
                link: id,
            });
            setFrames(data.frames);
        };
        if (user) {
            setLoading(true);
            const fetchData = async () => {
                try {
                    await Promise.all([
                        getGame(),
                        getGameFrames(),
                        getClubPlayers(user.id)
                    ]);
                } catch (e) {
                    console.error('Failed to fetch game data:', e);
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        }
    }, [user, id]);

    if (loading) {
        return (
            <div className="page-wrapper">
                <div className="page-body">
                    <div className="container-xl w-100">
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page-wrapper">
            <div className="page-header d-print-none">
                <div className="container-xl">
                    <div className="row g-2 align-items-center">
                        <div className="col">
                            <div className="page-pretitle">
                                Statistics
                            </div>
                            <h2 className="page-title">
                                {game.name || ''}
                            </h2>
                        </div>
                        <div className="col-auto ms-auto d-print-none d-flex" style={{ gap: 10 }}>

                        </div>
                    </div>
                </div>
            </div>
            <div className="page-body">
                <div className="container-xl w-100">
                    <div className="row row-deck row-cards">
                        <div className="col-12 col-sm-6 col-md-4">
                            <div className="card card-sm">
                                <div className="card-body">
                                    <div className="row align-items-center">
                                        <div className="col-auto">
                                            <span className="bg-primary text-white avatar">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-sport-billard">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M12 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                                                    <path d="M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                                                    <path d="M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0" />
                                                </svg>
                                            </span>
                                        </div>
                                        <div className="col">
                                            <div className="font-weight-medium">
                                                Players
                                            </div>
                                            <div className="text-secondary">
                                                {game.first_player_name && game.second_player_name
                                                    ? `${game.first_player_name} VS ${game.second_player_name}`
                                                    : 'Loading...'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {game && game.is_race ?
                            <div className="col-12 col-sm-6 col-md-4">
                                <div className="card card-sm">
                                    <div className="card-body">
                                        <div className="row align-items-center">
                                            <div className="col-auto">
                                                <span className="bg-warning text-white avatar">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-stopwatch">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M5 13a7 7 0 1 0 14 0a7 7 0 0 0 -14 0z" />
                                                        <path d="M14.5 10.5l-2.5 2.5" />
                                                        <path d="M17 8l1 -1" />
                                                        <path d="M14 3h-4" />
                                                    </svg>
                                                </span>
                                            </div>
                                            <div className="col">
                                                <div className="font-weight-medium">
                                                    Race to
                                                </div>
                                                <div className="text-secondary">
                                                    {game.race_to || ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : <div className="col-12 col-sm-6 col-md-4">
                                <div className="card card-sm">
                                    <div className="card-body">
                                        <div className="row align-items-center">
                                            <div className="col-auto">
                                                <span className="bg-warning text-white avatar">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-stopwatch">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M5 13a7 7 0 1 0 14 0a7 7 0 0 0 -14 0z" />
                                                        <path d="M14.5 10.5l-2.5 2.5" />
                                                        <path d="M17 8l1 -1" />
                                                        <path d="M14 3h-4" />
                                                    </svg>
                                                </span>
                                            </div>
                                            <div className="col">
                                                <div className="font-weight-medium">
                                                    Played frames
                                                </div>
                                                <div className="text-secondary">
                                                    {frames.length}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {game && game.is_race ?
                            <div className="col-12 col-sm-6 col-md-4">
                                <div className="card card-sm">
                                    <div className="card-body">
                                        <div className="row align-items-center">
                                            <div className="col-auto">
                                                <span className="bg-green text-white avatar">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-trophy">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M8 21l8 0" />
                                                        <path d="M12 17l0 4" />
                                                        <path d="M7 4l10 0" />
                                                        <path d="M17 4v8a5 5 0 0 1 -10 0v-8" />
                                                        <path d="M5 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                                                        <path d="M19 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                                                    </svg>
                                                </span>
                                            </div>
                                            <div className="col">
                                                <div className="font-weight-medium">
                                                    Winner
                                                </div>
                                                <div className="text-secondary">
                                                    {getPlayerName(game.winner) || 'TBD'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : null
                        }
                        <div className="col-12 col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Game frames</h3>
                                </div>
                                <div className="list-group list-group-flush overflow-auto" style={{ maxHeight: '25rem' }}>
                                    {frames.map((frame, i) => (
                                        <div key={i} className="list-group-item">
                                            <div className="row">
                                                <div className="col-auto d-flex justify-content-center align-items-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-topology-star-ring-3">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                        <path d="M10 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
                                                        <path d="M18 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
                                                        <path d="M10 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
                                                        <path d="M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
                                                        <path d="M18 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
                                                        <path d="M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
                                                        <path d="M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z" />
                                                        <path d="M6 12h4" />
                                                        <path d="M14 12h4" />
                                                        <path d="M15 7l-2 3" />
                                                        <path d="M9 7l2 3" />
                                                        <path d="M11 14l-2 3" />
                                                        <path d="M13 14l2 3" />
                                                        <path d="M10 5h4" />
                                                        <path d="M10 19h4" />
                                                        <path d="M17 17l2 -3" />
                                                        <path d="M19 10l-2 -3" />
                                                        <path d="M7 7l-2 3" />
                                                        <path d="M5 14l2 3" />
                                                    </svg>
                                                </div>
                                                {game && game.is_race ?
                                                    <div className="col text-truncate">
                                                        <span className="text-body d-block">Frame {frame.frame_nb}</span>
                                                    </div>
                                                    : null
                                                }
                                                <div className="col text-truncate">
                                                    <span className="text-body d-block">Winner ({getPlayerName(frame.winner) || 'Unknown'})</span>
                                                </div>
                                                <div className="col text-truncate">
                                                    <div className="text-secondary text-truncate mt-n1">{frameStatisticsTimestamp(frame) ? new Date(frameStatisticsTimestamp(frame)).toLocaleString() : ''}</div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GameStats;
